import Frome from "../../componets/From";
import "../Headline/Headline.css";
import navbar from "../Headline/navbar.png";
import welcome from "../Headline/welcome.png";
const Headline = () => {
  return (
    <>
      <div className="healine">
        <div className="healine1">
          <div className="healinenavdiv">
            <div className="headnavbar">
              <img src={navbar} />
              <p style={{ color: "black" }}> festhers</p>
              <p style={{ color: "black" }}>Studio Pro</p>
              <p style={{ color: "black", marginLeft: "43%" }}>Sign In</p>
            </div>
            <div style={{ paddingTop: "104px" }}>
              <h1
                style={{
                  marginTop: "0px",
                  width: "70%",
                  textAlign: "",
                  marginLeft: "7%",
                  fontSize: "45px",
                  color: "rgb(71,71,71)",
                }}
              >
                Write better headlines that will boost your traffic.{" "}
              </h1>
              <div
                style={{
                  backgroundColor: "#6ac694",
                  color: "white",
                  borderRadius: "50%",
                  fontSize: "20px",
                  width: "25px",
                  marginTop: "-85PX",
                  marginLeft: "30%",
                  padding: "3px",
                }}
              >
                76
              </div>
              <p
                style={{
                  color: "black",
                  marginTop: "55px",
                  marginLeft: "7%",
                  fontSize: "20px",
                }}
              >
                Eliminate guesswork and outperform your competition with
                Headline Studio.
              </p>
              <img style={{ width: "80%", marginLeft: "7%" }} src={welcome} />
              <div style={{margin:"auto",justifyContent:"center",width:"50%"}}>
                  <h1 style={{textAlign:"center",color:"rgb(71,71,71)"}}>Want people to read your content?</h1>
                  <div style={{width:"150px",height:"5px",backgroundColor: "#6ac694",margin:"auto"}}></div>
                  <p style={{textAlign:"center",marginTop:"50px"}}>They’ll start with your headline. And that’s as far as they’ll get.</p>
                  <p style={{textAlign:"center"}}>If your headline doesn’t convince your readers to take action, it’s meaningless.</p>
              </div>
               <div style={{display:"flex",width:"100%",margin:"auto",justifyContent:"center",marginTop:"100px",fontWeight:"bold"}}>
                   <div  style={{width:"24%"}}>
                       <img style={{width:"10%",marginLeft:"40%"}}  src="https://cdn2.iconfinder.com/data/icons/web-and-apps-interface/32/Cancel-512.png"/>
                       <p>Stop wasting time on headlines that don’t drive traffic.</p>

                   </div>
                   <div style={{width:"30%",marginLeft:"200px"}}>
                   <img style={{width:"9%",marginLeft:"40%"}} src="https://www.freeiconspng.com/thumbs/check-tick-icon/green-tick-icon-0.png"/>
                   <p>Finally know how to write better headlines & drive maximum traffic.</p>
                   </div>
               </div>
                <div className="headnavDavid" >
                 <img  src="https://coschedule.com/img/headline-studio/quotation-green.svg" />
                 <div>On average, 5x as many people read the headline as read the body copy. When you’ve written your headline, you’ve spent eighty cents out of your dollar.
</div>
               <p>DAVID OGILVY</p>
                </div>
                <div  style={{width:"42%",justifyContent:"center",margin:"auto",marginTop:"100px",textAlign:"center"}}>
                    <h1 style={{color:"rgb(71,71,71)"}}>Headline Studio</h1>
                    <p>brings you millions of all-new, actionable suggestions that tell you EXACTLY how to improve your headlines.</p>
               
                </div>
                <img  style={{width:"82%",marginLeft:"100px"}} src="https://coschedule.com/img/headline-studio/headline-studio-screen.png" />
            </div>
            <div style={{width:"76%", margin:"auto",display:"flex"}}>
              <div ><samp style={{color:"rgb(71,71,71)",fontSize:"20px",fontWeight:"bold"}}>Create better headlines</samp> with tons of upgraded headline recommendations, resources, and inspiration—in just one tool.</div>
              <div style={{marginLeft:"51px",marginRight:"0px"}}><samp style={{color:"rgb(71,71,71)",fontSize:"20px",fontWeight:"bold"}}>And finally feel confident</samp> that every headline you write drives maximum traffic, engagement, and SEO rankings.</div>
            </div>
            <div style={{margin:"auto",justifyContent:"center",width:"50%",marginTop:"100px"}}>
                  <h1 style={{textAlign:"center",color:"rgb(71,71,71)"}}>Write better headlines guaranteed to boost your traffic.</h1>
                  <div style={{width:"150px",height:"5px",backgroundColor: "#6ac694",margin:"auto"}}></div>
                  <svg  style={{marginLeft:"450px",marginTop:"-60px"}}  version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.7 18c15 67.9 94.8 28.7 62.9 8-38.2-24.7-55.8 73 38.8 76.6" fill="none" stroke="#6ac694" stroke-width="3" stroke-linecap="round" stroke-miterlimit="10"></path>
                        <path d="M113.3 93.3s16.4 6 17.9 8.9c1.4 2.7-13.2 8.4-17.1 11.4" fill="none" stroke="#6ac694" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"></path>
                    </svg>
              </div>
              <div   style={{backgroundColor:"white",marginTop:"0px"}}  className="headnavDavid" >
                 <img  src="https://coschedule.com/img/headline-studio/quotation-green.svg" />
                 <div  style={{color:"#88a6f8"}}>When I started blogging, my headlines were pretty pedestrian. With Headline Studio, they sizzle. My SEO has improved as a result.
</div>
               <p>WILLIAM RICHARDSON</p>
                </div>

             <div  style={{display:"flex",margin:"auto",justifyContent:"center"}}>
                 <div  style={{width:"38%"}}>
                     <h1 style={{color:"rgb(71,71,71)"}}>Analyze headlines 10x faster with 5x more feedback.</h1>
                     <div style={{width:"150px",height:"3px",backgroundColor: "#6ac694"}}></div>
                     <p>Start writing next-level headlines that actually get seen, clicked, and shared with the help of Headline Studio.</p>
                 </div>
                 <div  className="feedback">
                     <div >
                     <img  src="https://coschedule.com/img/headline-studio/hs-analyze-headlines-faster.svg"/>
                     <h4>Analyze headlines 10x faster</h4>
                     <p>with an all-new, time-saving algorithm.</p>
                     </div>
                     <div >
                     <img  src="	https://coschedule.com/img/headline-studio/hs-gain-more-feedback.svg"/>
                     <h4>Gain 5x more headline feedback</h4>
                     <p>with advanced analysis from thousands of data points.</p>
                     </div>
                     <div >
                     <img  src="	https://coschedule.com/img/headline-studio/hs-outperform-the-competition.svg"/>
                     <h4>Outperform competing headlines</h4>
                     <p>by making changes that boost your headline score.</p>
                     </div>
                     <div >
                     <img  src="	https://coschedule.com/img/headline-studio/hs-optimize-headlines-anywhere.svg"/>
                     <h4>Optimize headlines on any site</h4>
                     <p>where you write them with a free browser extension.</p>
                     </div>
                 </div>
             </div>
             < div className="hea-browser">
                 <div className=" hea-browserextesion">
                 <p>BROWSER EXTENSION</p>
                  <h1>Write and analyze side-by-side</h1>
                 <p><samp style={{color:"#5d90f5",fontSize:"16px"}}>Download the free browser extension</samp> to use Headline Studio on any site where you write content. Seamlessly analyze your headlines right in WordPress, Wix, and more.</p>
             </div>
              <div>
                 <img  src="https://coschedule.com/img/headline-studio/hs-feature-browser-extension.png" />
             </div> 
             </div>
             < div className="hea-browser">
             <div>
                 <img  src="	https://coschedule.com/img/headline-studio/hs-feature-scorecard-1.png" />
             </div> 
                 <div className=" hea-browserextesion">
                 <p>SCORECARD</p>
                  <h1>Score your headlines 10x faster</h1>
                 <p>Analyze more headlines, more quickly with an all-new algorithm. See which types of changes will strengthen your score based on <samp style={{color:"black",fontSize:"16px",fontWeight:"bold"}}>proven data from 4+ million headlines.</samp></p>
             </div>
            
              
             </div>
             < div className="hea-browser">
                 <div  className=" hea-browserextesion"  style={{width:"48%"}}>
                 <p>HISTORY</p>
                  <h1>Revisit your past headlines</h1>
                 <p>Access a history of your past headlines. Easily find, tweak, or reuse headlines that have performed well for you.</p>
             </div>
              <div>
                 <img  src="https://coschedule.com/img/headline-studio/hs-feature-history-1.png" />
             </div> 
             </div>
             <div style={{margin:"auto",justifyContent:"center",width:"56%"}}>
                  <h1 style={{textAlign:"center",color:"rgb(71,71,71)"}}>Trusted by more than 1 million marketers</h1>
                  <div style={{width:"150px",height:"5px",backgroundColor: "#6ac694",margin:"auto"}}></div>
                  <p style={{textAlign:"center",marginTop:"50px"}}>Their headlines are grabbing attention and growing results.</p>
                  <p style={{textAlign:"center",marginTop:"0px",fontStyle:"italic"}}>What are you waiting for?</p>
                
              </div>
            <div  style={{width:"50%",marginLeft:"10%",marginTop:"50px"}}>
            <img  style={{width:"7%"}} src="https://coschedule.com/img/headline-studio/quotation-blue.svg" /> 
            <p style={{color:"#88a6f8",fontSize:"20px",lineHeight:"30PX"}}>GREATEST INVENTION EVER!! Yeah, I shouted that. Headline Studio has hooked more people to my blog. So, THANK YOU!</p>
            <p style={{color:"gray",fontSize:"14px",fontWeight:"bold"}}>MEL A. ROWE, BESTSELLING AUTHOR</p>
            </div>
            <div  style={{width:"50%",marginLeft:"40%",marginTop:"50px"}}>
            <img  style={{width:"7%"}} src="https://coschedule.com/img/headline-studio/quotation-blue.svg" /> 
            <p style={{color:"#88a6f8",fontSize:"20px",lineHeight:"30PX"}}>Even after 10 years of writing, I still get headlines wrong sometimes. Headline Studio helps ensure my headlines will work.</p>
            <p style={{color:"gray",fontSize:"14px",fontWeight:"bold"}}>LAURA PENCE ATENCIO, SOCIAL SAVVY GEEK
</p>
            </div>
            <div  style={{width:"50%",marginLeft:"10%",marginTop:"50px"}}>
            <img  style={{width:"7%"}} src="https://coschedule.com/img/headline-studio/quotation-blue.svg" /> 
            <p style={{color:"#88a6f8",fontSize:"20px",lineHeight:"30PX"}}>I finally feel confident that I’m creating a great headline that will attract readers.</p>
            <p style={{color:"gray",fontSize:"14px",fontWeight:"bold"}}>DOMINICA MCGINNIS, BRIDGEFIELD GROUP
</p>
            </div>
             <div style={{width:"80%",justifyContent:"center",margin:"auto",marginTop:"100px"}}>
                 <img   style={{width:"90%"}}  src="https://coschedule.com/img/headline-studio/as-featured-by-logos-lg.png"/>
                 </div>
                 <div className="headline-studio">
                     <p>HEADLINE STUDIO PRO</p>
                     <h1>Want even more headline-boosting capabilities?</h1>
                     <div  style={{display:"flex",margin:"auto",justifyContent:"center"}}>
                         <p style={{fontSize:"20px"}}>Upgrade to Headline Studio Pro to unlock these</p>
                         <div style={{display:"flex" ,width:"100px",height:"25px",border:"1px solid #5d90f5",backgroundColor:"white",marginTop:"20px", borderRadius:"5px",marginLeft:"5px",marginRight:"5px"}}>
                             <img  width="15%" src="https://coschedule.com/img/headline-studio/hs-premium-icon.svg"/>
                              <p  style={{color:"#2269f6",marginTop:"-3px",padding:"5px",fontWeight:"bold"}}>PREMIUM</p>

                         </div>
                         <p style={{fontSize:"20px"}}>features.</p>
                         
                     </div>
                     < div className="hea-browser">
             <div>
                 <img  src="	https://coschedule.com/img/headline-studio/hs-feature-suggestions-1.png" />
             </div> 
                 <div className=" hea-browserextesion">
                     <div style={{display:"flex"}}> <p className="P">SUGGESTIONS</p>
                     <img style= {{marginTop:"14px"}} width="4%" src="https://coschedule.com/img/headline-studio/hs-premium-icon.svg"/>
                     </div>
                
                  <h1>Improve headlines with data-driven suggestions</h1>
                 <p>Instantly improve your score with smart suggestions based on millions of words. Feel confident that your headline is written to drive results.</p>
             </div>
            
              
             </div>
             < div className="hea-browser">
                 <div  className=" hea-browserextesion"  style={{width:"48%"}}>
                 <div style={{display:"flex"}}> <p className="P">SEO SCORE</p>
                     <img style= {{marginTop:"14px"}} width="4%" src="https://coschedule.com/img/headline-studio/hs-premium-icon.svg"/>
                     </div>
                  <h1>Boost your search rankings</h1>
                 <p>Optimize your headlines for search engine results. Get SEO suggestions to help your headlines rank higher and reach a larger, more engaged audience.</p>
             </div>
              <div>
                 <img  src="https://coschedule.com/img/headline-studio/hs-feature-seo-score-1.png" />
             </div> 
             </div>
             < div className="hea-browser">
             <div>
                 <img  src="https://coschedule.com/img/headline-studio/hs-feature-keyword-explorer-1.png" />
             </div> 
                 <div className=" hea-browserextesion">
                     <div style={{display:"flex"}}> <p className="P">KEYWORD EXPLORER</p>
                     <img style= {{marginTop:"14px"}} width="4%" src="https://coschedule.com/img/headline-studio/hs-premium-icon.svg"/>
                     </div>
                
                  <h1>Find the best keywords</h1>
                 <p>See the detailed performance data behind each of your keywords and find out which ones will perform best in your headline.</p>
             </div>
            
              
             </div>
             < div className="hea-browser">
                 <div  className=" hea-browserextesion"  style={{width:"48%"}}>
                 <div style={{display:"flex"}}> <p className="P">FAVORITES</p>
                     <img style= {{marginTop:"14px"}} width="4%" src="https://coschedule.com/img/headline-studio/hs-premium-icon.svg"/>
                     </div>
                  <h1>Save your favorite headlines</h1>
                 <p>Star the versions of headlines you like best. They’ll stay at the top of your list so you can easily find and pull them into your content.</p>
             </div>
              <div>
                 <img  src="https://coschedule.com/img/headline-studio/hs-feature-history-1.png" />
             </div> 
             </div>
             < div className="hea-browser" style={{marginBottom:"50px"}}>
             <div>
                 <img  src="https://coschedule.com/img/headline-studio/hs-feature-thesaurus-1.png" />
             </div> 
                 <div className=" hea-browserextesion" >
                     <div style={{display:"flex"}}> <p className="P">WORD BANKS</p>
                     <img style= {{marginTop:"14px"}} width="4%" src="https://coschedule.com/img/headline-studio/hs-premium-icon.svg"/>
                     </div>
                
                  <h1>Find high-scoring words instantly</h1>
                 <p>Access a full thesaurus and power + emotional Word Banks, right inside Headline Studio. Easily find synonyms and alternate word options to boost your score and increase engagement.</p>
             </div>
            
              
             </div>
            
                 </div>
                <h1  style={{marginTop:"100px", textAlign:"center"}}>Frequently Asked Questions</h1>
                <div style={{width:"150px",height:"5px",backgroundColor: "#6ac694",margin:"auto"}}></div>
                <div className="qution">
                     <div>
                      <div>
                          <h4>
                          How many times can I analyze each headline?
                          </h4>
                          <p>Headline Studio allows you to analyze up to 25 versions of each headline. When you reach your limit of versions for a headline, you can use a new headline to keep analyzing.</p>
                      </div>
                      <div>
                          <h4>
                          What’s the difference between headlines and versions?
                          </h4>
                          <p>Versions are the iterations of each headline that you reanalyze. For example, you might write and reanalyze 10 different versions of a single blog headline before moving on to a different headline for another piece of content.</p>
                      </div>
                      <div>
                          <h4>
                          How many headlines will I need?
                          </h4>
                          <p>That depends on how much content you write. If you write 5+ blogs each month, we recommend a higher-headline plan. If you write just a few, try a smaller plan.</p>
                      </div>
                      <div>
                          <h4>
                          Can I switch to a different plan?
                          </h4>
                          <p>Yes. To switch to a different Headline Studio plan, just visit the billing page in your CoSchedule account.</p>
                      </div>
                      <div>
                          <h4>
                          What happens if I run out of Premium Headlines?
                          </h4>
                          <p>If you’re already in a Headline Studio Pro plan, your headline quota will reset at the beginning of the next month. If you don’t want to wait (or you’re using Headline Studio Free), upgrade your Headline Studio Pro plan.</p>
                      </div>
                     </div>
                     <div>
                     <div>
                          <h4>
                          What’s the difference between Premium Headlines and Standard Headlines?
                          </h4>
                          <p>Premium Headlines are analyzed with premium features only available in Headline Studio Pro. Standard Headlines are analyzed with limited features in Headline Studio Free.</p>
                      </div>
                      <div>
                          <h4>
                          Can I try Headline Studio Pro before I buy?

                          </h4>
                          <p>No, but you’ll receive 3 free Premium Headlines to try out when you start a Headline Studio Free plan.</p>
                      </div>
                      <div>
                          <h4>
                          What if I need more than 60 headlines?

                          </h4>
                          <p>Contact CoSchedule Support to increase your headline limit and get additional pricing information.</p>
                      </div>
                      <div>
                          <h4>
                          Will my unused headlines roll over to next month?
                          </h4>
                          <p>No. Your headline count will automatically reset to your monthly quota at the beginning of each month.</p>
                      </div>
                     </div>
                </div>
          </div>
       
        </div>
        <div className="healine2">
            <div className="studioFrees">
            <h1>Start Using Headline Studio For Free</h1>
            </div>
            <Frome/>
            <button  className="button-h">
                Get Started Now
            </button>
            <div className="get-started">
                <p>By clicking "Get Started Now", you agree to CoSchedule’s terms of service, end user agreement, and privacy policy; you are 16 years or older; and you will receive information from CoSchedule from which you can opt out at any time.</p>
            </div>
            
        </div>
      </div>
    </>
  );
};

export default Headline;
